module.exports = __webpack_public_path__ + "static/media/vu_glass.0770b316.png";